import { PaletteColorKeys } from "src/theme/themeConfiguration";
import { CSSProperties } from "react";
import { makeStyles } from "tss-react/mui";

interface IParams {
    cardPaddingBottom?: CSSProperties["paddingBottom"];
    chipVariant?: PaletteColorKeys;
    expand?: boolean;
    footerBackgroundColor?: string;
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    boxContainer: {
        position: "relative",
        width: "100%",
    },
    card: {
        paddingBottom: props.cardPaddingBottom,
        position: "relative",
        zIndex: 100,
    },
    cardHeaderContainer: {
        position: "relative",
    },
    chip: {
        backgroundColor: theme.palette.background.main,
        color: theme.palette.secondary.main,
        height: 24,
    },
    chipDesktop: {
        position: "absolute",
        right: "5%",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 110,
    },
    chipCircle: {
        "&.MuiChip-avatar": {
            width: 10,
            height: 10,
            marginLeft: 10,
        },
        borderRadius: "50%",
        backgroundColor: props.chipVariant && theme.palette[props.chipVariant].main,
    },
    expandButtonContainer: {
        position: "absolute",
        width: 50,
        height: 25,
        bottom: 0,
        left: "50%",
        transform: "translate(-50%, 99%)",
        backgroundColor: props.expand
            ? props.footerBackgroundColor ?? theme.palette.primary.contrastText
            : theme.palette.secondary.main,
        border: "none",
        borderRadius: "0 0 50px 50px",
        cursor: "pointer",
        transition: "0.2s ease-in",
        zIndex: 110,
    },
    expandButtonDecoration: {
        position: "absolute",
        width: 50,
        height: 50,
        bottom: 0,
        left: "50%",
        transform: "translate(-50%, 50%)",
        backgroundColor: "transparent",
        borderRadius: "50%",
        boxShadow:
            "0px 0px 8px 0px rgba(0, 0, 0, 0)," +
            "0px 0px 4px 0px rgba(0, 0, 0, 0), " +
            "0px 0px 7px 2px rgba(0, 0, 0, 0.11);",
        zIndex: 90,
    },
    expandButtonIcon: {
        color: props.expand ? theme.palette.secondary.main : theme.palette.primary.contrastText,
        position: "absolute",
        left: "50%",
        transform: `translate(-50%, ${props.expand ? "-85%" : "-55%"})`,
        transition: "0.2s ease-in",
    },
}));
